import { Link } from 'ui/components/primitives';
import { styled, theme, utils } from 'ui/theme';

export const ProductsComponents = {
  ButtonCombo: styled(Link)`
    &:hover {
      text-decoration: none;
    }
    &[data-active='true'] {
      text-decoration: none;
    }

    ${utils.media.max('s')`
    button {
      padding: 0
    }
  `}
  `,
  WrapperCarousel: styled.div`
    margin: 0 calc(-1 * ${theme.space[4]});
    overflow: hidden;
    position: relative;

    ${utils.media.min('l')`
      padding: 0;
      margin: 0;
      overflow: initial;
    `}
  `,
};
